module.exports = __webpack_public_path__ + "assets/1-sales-development-rep-job-information.873b54fa.png";